import {useMemo} from "react";
import {FiPlus} from "react-icons/fi";
import {Link} from "react-router";

import Button from "@/components/button/Button.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {TabContentContainer} from "@/components/layout/TabContentContainer.tsx";
import {dynamicTabConfig, TabConfig} from "@/components/layout/TabContentContainer.types.ts";
import {TabContextProvider, useTabs} from "@/lib/hooks/useTabs.tsx";
import {MaintenanceSchedule} from "@/lib/types/maintenance.ts";
import {MaintenanceDashboardTabs} from "@/pages/maintenance/maintenance-dashboard/MaintenanceDashboard.types.ts";
import {
  defaultMaintenanceDashboardConfig,
  StaticMaintenanceDashboardTabConfig,
} from "@/pages/maintenance/maintenance-dashboard/MaintenanceDashboard.utils.tsx";

export const MaintenanceDashboard = () => {
  const methods = useTabs({
    defaultTab: MaintenanceDashboardTabs.ACTIVE,
    blockerFunction: undefined,
    tabList: Object.values(MaintenanceDashboardTabs),
  });
  const {tab, changeTab: setTab} = methods;

  const sections: Record<string, TabConfig<void, MaintenanceSchedule[]>> = useMemo(() => {
    const derivedSections: Record<string, TabConfig<void, MaintenanceSchedule[]>> = StaticMaintenanceDashboardTabConfig;
    Object.keys(derivedSections).forEach((key) => {
      const tabKey = key as MaintenanceDashboardTabs;

      const dynamicConfig: dynamicTabConfig = {
        ...defaultMaintenanceDashboardConfig[tabKey],
      };

      derivedSections[tabKey] = {
        ...derivedSections[tabKey],
        ...dynamicConfig,
      };
    });
    return derivedSections;
  }, []);

  return (
    <TabContextProvider {...methods}>
      <TabContentContainer
        className={"mb-0"}
        sections={sections}
        tab={tab}
        setTab={setTab}
        title="Maintenance Windows"
        actionsBar={
          <Button size={"large"} variant={"primary"} as={Link} to={"/maintenance/schedules/create"}>
            <Icon icon={FiPlus} /> Create Schedule
          </Button>
        }
      >
        {sections[tab].html()}
      </TabContentContainer>
    </TabContextProvider>
  );
};
